(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Sidebar filter: auto-submit on checkbox change (fallback for browsers that block inline handlers)
  document.addEventListener('DOMContentLoaded', () => {
    const sidebarForm = document.getElementById('coll-sidebar-form');
    if (!sidebarForm) return;
    sidebarForm.querySelectorAll('input[type="checkbox"]').forEach((cb) => {
      cb.addEventListener('change', function () { this.closest('form').submit(); });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
